<template>
  <div style="text-align: center;">
    <div style="min-height: 200px;"></div>
    <v-progress-circular :size="70" :width="7" color="#d96c6c" indeterminate></v-progress-circular>
  </div>
</template>

<script>
export default {};
</script>
